
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","viewBox":"0 0 64 64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.19 0H16.83C7.54 0 0 6.2 0 13.84V49.48C0 57.5 7.9 64 17.66 64H47.19C56.48 64 64.02 57.82 64 50.18V13.82C64 6.18 56.48 0 47.19 0ZM40.6 20.43C40.6 20.75 40.34 21.01 40.02 21.01H36.63C35.44 21.01 34.83 21.58 34.83 22.7V26.42H40.02C40.18 26.42 40.34 26.49 40.45 26.61C40.56 26.73 40.61 26.9 40.59 27.06L39.91 33C39.88 33.29 39.63 33.51 39.34 33.51H34.84V49.56C34.84 49.88 34.58 50.14 34.26 50.14H27.62C27.3 50.14 27.04 49.88 27.04 49.56V33.43H23.12C22.8 33.43 22.54 33.17 22.54 32.85V26.99C22.54 26.67 22.8 26.41 23.12 26.41H27.23V23.14C27.23 22.62 27.21 22.11 27.18 21.6C27.12 20.62 27.26 18.46 29.27 16.6C31.5 14.55 34.32 14.39 35.13 14.39C35.24 14.39 35.31 14.39 35.34 14.39H40.02C40.34 14.39 40.6 14.65 40.6 14.97V20.42V20.43Z","fill":"#D20311"}})])
          )
        }
      }
    